// src/stores/themeStore.js
import { writable } from 'svelte/store';

// 기본값을 'false'로 설정 (다크모드를 기본적으로 비활성화)
export const isDarkMode = writable(false);